import React, { useCallback, useEffect, useState } from "react";
import api from "../api";

const ago = (d) => {
  if (!d) return "never";
  const m = Math.round((Date.now() - new Date(d)) / 60000);
  return m < 1 ? "just now" : m < 60 ? `${m} min ago` : m < 1440 ? `${Math.round(m / 60)} h ago` : `${Math.round(m / 1440)} d ago`;
};
const stale = (d) => !d || Date.now() - new Date(d) > 15 * 60000;

export default function AgentServers() {
  const [servers, setServers] = useState([]);
  const [tokens, setTokens] = useState([]);
  const [form, setForm] = useState({ label: "", ttlHours: 24, maxUses: 1 });
  const [fresh, setFresh] = useState(null);
  const [err, setErr] = useState("");
  const load = useCallback(() => {
    api.get("/agent-servers").then((r) => setServers(r.data?.data || [])).catch((e) => setErr(e?.response?.data?.message || e.message));
    api.get("/agent-servers/enrollment-tokens").then((r) => setTokens(r.data?.data || [])).catch(() => {});
  }, []);
  useEffect(() => { load(); const i = setInterval(load, 30000); return () => clearInterval(i); }, [load]);
  const mint = async (e) => {
    e.preventDefault(); setErr("");
    try { const r = await api.post("/agent-servers/enrollment-tokens", form); setFresh(r.data?.data); load(); }
    catch (x) { setErr(x?.response?.data?.message || x.message); }
  };
  const revoke = async (url, what) => { if (window.confirm(`Revoke this ${what}?`)) { await api.post(url); load(); } };
  return (
    <div>
      <h1>Agent Servers</h1>
      {err && <div className="err" style={{ marginBottom: 10 }}>{err}</div>}
      <div className="card" style={{ marginBottom: 16 }}>
        <div className="toolbar"><strong>Enrolled servers</strong></div>
        <table>
          <thead><tr><th>Name</th><th>Host</th><th>Version</th><th>Status</th><th>Last seen</th><th>Last IP</th><th /></tr></thead>
          <tbody>
            {servers.map((s) => (
              <tr key={s.id}>
                <td>{s.name}</td><td>{s.hostname || "—"}</td><td>{s.version || "—"}</td>
                <td><span className="pill">{s.status === "Revoked" ? "Revoked" : stale(s.last_seen_at) ? "Offline" : "Online"}</span></td>
                <td>{ago(s.last_seen_at)}</td><td>{s.last_ip || "—"}</td>
                <td>{s.status === "Active" && <button className="btn sm" onClick={() => revoke(`/agent-servers/${s.id}/revoke`, "Agent Server")}>Revoke</button>}</td>
              </tr>
            ))}
            {!servers.length && <tr><td colSpan={7} style={{ textAlign: "center", padding: 20 }}>No Agent Server enrolled yet</td></tr>}
          </tbody>
        </table>
      </div>
      <div className="card">
        <div className="toolbar"><strong>Enrollment tokens</strong></div>
        <form onSubmit={mint} style={{ padding: 12, display: "flex", gap: 10, flexWrap: "wrap", alignItems: "end" }}>
          <div className="form-row"><label>Label</label><input value={form.label} onChange={(e) => setForm({ ...form, label: e.target.value })} placeholder="Head office server" /></div>
          <div className="form-row"><label>Valid (hours, max 168)</label><input type="number" min="1" max="168" value={form.ttlHours} onChange={(e) => setForm({ ...form, ttlHours: e.target.value })} /></div>
          <div className="form-row"><label>Max uses</label><input type="number" min="1" max="50" value={form.maxUses} onChange={(e) => setForm({ ...form, maxUses: e.target.value })} /></div>
          <button className="btn primary">Generate token</button>
        </form>
        {fresh && (
          <div style={{ padding: "0 12px 12px" }}>
            <div>Copy this token now, it will not be shown again (expires {new Date(fresh.expiresAt).toLocaleString()}):</div>
            <input readOnly style={{ width: "100%", fontFamily: "monospace" }} value={fresh.token} onFocus={(e) => e.target.select()} />
          </div>
        )}
        <table>
          <thead><tr><th>Label</th><th>Expires</th><th>Used</th><th>State</th><th>By</th><th /></tr></thead>
          <tbody>
            {tokens.map((t) => (
              <tr key={t.id}>
                <td>{t.label || "—"}</td><td>{new Date(t.expires_at).toLocaleString()}</td><td>{t.used_count}/{t.max_uses}</td>
                <td>{t.revoked ? "Revoked" : new Date(t.expires_at) < new Date() ? "Expired" : t.used_count >= t.max_uses ? "Used" : "Valid"}</td>
                <td>{t.created_by || "—"}</td>
                <td>{!t.revoked && <button className="btn sm" onClick={() => revoke(`/agent-servers/enrollment-tokens/${t.id}/revoke`, "token")}>Revoke</button>}</td>
              </tr>
            ))}
            {!tokens.length && <tr><td colSpan={6} style={{ textAlign: "center", padding: 20 }}>No tokens</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
